export default "__VITE_ASSET__BbLptlhh__"